import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export class MessageCypressAttribute extends CypressAttribute {
  static buttons = {
    SEND: 'MessageCypressAttribute:buttons:SEND',
    INLINE_SEND: 'MessageCypressAttribute:buttons:INLINE_SEND',
    COPY_TO_CLIPBOARD: 'MessageCypressAttribute:buttons:COPY_TO_CLIPBOARD',
    UNDO_DELETE: 'MessageCypressAttribute:buttons:UNDO_DELETE',
    CLARA_DRAFT_DISCARD: 'MessageCypressAttribute:buttons:CLARA_DRAFT_DISCARD',
    CLARA_DRAFT_EDIT: 'MessageCypressAttribute:buttons:CLARA_DRAFT_EDIT',
    CLARA_DRAFT_SEND: 'MessageCypressAttribute:buttons:CLARA_DRAFT_SEND',
    CLARA_DRAFT_SOURCES: 'MessageCypressAttribute:buttons:CLARA_DRAFT_SOURCES',
    CLARA_DRAFT_CANCEL_EDIT: 'MessageCypressAttribute:buttons:CLARA_DRAFT_CANCEL_EDIT',
    CLARA_DRAFT_SOURCE_OPEN: 'MessageCypressAttribute:buttons:CLARA_DRAFT_SOURCE_OPEN'
  };

  static inputs = {
    CLARA_DRAFT_EDITOR: 'MessageCypressAttribute:inputs:CLARA_DRAFT_EDITOR',
    CLARA_DRAFT_DISCARD_REASON: 'MessageCypressAttribute:inputs:CLARA_DRAFT_DISCARD_REASON',
    CLARA_DRAFT_DISCARD_DESCRIPTION:
      'MessageCypressAttribute:inputs:CLARA_DRAFT_DISCARD_DESCRIPTION'
  };

  static views = {
    CHAT_MESSAGES_LIST: 'MessageCypressAttribute:views:CHAT_MESSAGES_LIST',
    MESSAGE_VIEW: 'MessageCypressAttribute:views:MESSAGE_VIEW',
    MESSAGE_CONTENT: 'MessageCypressAttribute:views:MESSAGE_CONTENT',
    MESSAGE_TIME: 'MessageCypressAttribute:views:MESSAGE_TIME',
    CLARA_DRAFT_CARD: 'MessageCypressAttribute:views:CLARA_DRAFT_CARD',
    CLARA_DRAFT_TEXT: 'MessageCypressAttribute:views:CLARA_DRAFT_TEXT',
    CLARA_DRAFT_EVIDENCE: 'MessageCypressAttribute:views:CLARA_DRAFT_EVIDENCE',
    CLARA_DRAFT_EVIDENCE_TALLY: 'MessageCypressAttribute:views:CLARA_DRAFT_EVIDENCE_TALLY',
    CLARA_DRAFT_EVIDENCE_FACT: 'MessageCypressAttribute:views:CLARA_DRAFT_EVIDENCE_FACT',
    CLARA_DRAFT_EVIDENCE_LABEL: 'MessageCypressAttribute:views:CLARA_DRAFT_EVIDENCE_LABEL',
    CLARA_DRAFT_EVIDENCE_WARNING: 'MessageCypressAttribute:views:CLARA_DRAFT_EVIDENCE_WARNING',
    CLARA_DRAFT_EVIDENCE_DETAIL: 'MessageCypressAttribute:views:CLARA_DRAFT_EVIDENCE_DETAIL',
    CLARA_DRAFT_SOURCES_PANEL: 'MessageCypressAttribute:views:CLARA_DRAFT_SOURCES_PANEL',
    CLARA_DRAFT_THINKING_CARD: 'MessageCypressAttribute:views:CLARA_DRAFT_THINKING_CARD',
    CLARA_THINKING_INDICATOR: 'MessageCypressAttribute:views:CLARA_THINKING_INDICATOR',
    CLARA_THINKING_SPINNER: 'MessageCypressAttribute:views:CLARA_THINKING_SPINNER',
    CLARA_DRAFT_SOURCE: 'MessageCypressAttribute:views:CLARA_DRAFT_SOURCE',
    CLARA_DRAFT_SOURCE_TYPE: 'MessageCypressAttribute:views:CLARA_DRAFT_SOURCE_TYPE',
    CLARA_DRAFT_SOURCE_PARTNER: 'MessageCypressAttribute:views:CLARA_DRAFT_SOURCE_PARTNER',
    CLARA_DRAFT_SOURCE_FIELDS: 'MessageCypressAttribute:views:CLARA_DRAFT_SOURCE_FIELDS',
    CLARA_DRAFT_SOURCE_FIELD: 'MessageCypressAttribute:views:CLARA_DRAFT_SOURCE_FIELD',
    CLARA_DRAFT_SOURCE_FIELD_LABEL: 'MessageCypressAttribute:views:CLARA_DRAFT_SOURCE_FIELD_LABEL',
    CLARA_DRAFT_SOURCE_FIELD_VALUE: 'MessageCypressAttribute:views:CLARA_DRAFT_SOURCE_FIELD_VALUE',
    CLARA_DRAFT_SOURCE_ITEM: 'MessageCypressAttribute:views:CLARA_DRAFT_SOURCE_ITEM',
    CLARA_DRAFT_SOURCE_ITEM_LABEL: 'MessageCypressAttribute:views:CLARA_DRAFT_SOURCE_ITEM_LABEL',
    CLARA_DRAFT_SOURCE_ITEM_DESCRIPTION:
      'MessageCypressAttribute:views:CLARA_DRAFT_SOURCE_ITEM_DESCRIPTION',
    CLARA_DRAFT_EVIDENCE_SUMMARY: 'MessageCypressAttribute:views:CLARA_DRAFT_EVIDENCE_SUMMARY',
    CLARA_DRAFT_LOCKED_TOOLTIP: 'MessageCypressAttribute:views:CLARA_DRAFT_LOCKED_TOOLTIP',
    CLARA_DRAFT_COMPOSER_LOCKED_TOOLTIP:
      'MessageCypressAttribute:views:CLARA_DRAFT_COMPOSER_LOCKED_TOOLTIP'
  };
}
